import { render, staticRenderFns } from "./ResultFormItem.vue?vue&type=template&id=054a067c&scoped=true"
import script from "./ResultFormItem.vue?vue&type=script&lang=js"
export * from "./ResultFormItem.vue?vue&type=script&lang=js"
import style0 from "./ResultFormItem.vue?vue&type=style&index=0&id=054a067c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a067c",
  null
  
)

export default component.exports